export default "__VITE_ASSET__BmvxDGym__"